var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.0935H22V18.0935H0V16.0935H2V1.09351C2 0.828289 2.10536 0.573935 2.29289 0.386399C2.48043 0.198863 2.73478 0.0935059 3 0.0935059H13C13.2652 0.0935059 13.5196 0.198863 13.7071 0.386399C13.8946 0.573935 14 0.828289 14 1.09351V16.0935H16V6.09351H19C19.2652 6.09351 19.5196 6.19886 19.7071 6.3864C19.8946 6.57394 20 6.82829 20 7.09351V16.0935ZM6 8.09351V10.0935H10V8.09351H6ZM6 4.09351V6.09351H10V4.09351H6Z",
    fill: "#787E82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.09826fdee1efc8d240281fbd4f4cf79b.svg";
export { ForwardRef as ReactComponent };